// facility lookups
export const FETCH_FACILITY_LOOKUPS_REQ = 'FETCH_FACILITY_LOOKUPS_REQ';
export const FETCH_FACILITY_LOOKUPS_RES = 'FETCH_FACILITY_LOOKUPS_RES';
export const FETCH_FACILITY_LOOKUPS_ERR = 'FETCH_FACILITY_LOOKUPS_ERR';

//Register New Application
export const REGISTER_FACILITY_APPLICATION_REQ = 'REGISTER_FACILITY_APPLICATION_REQ';
export const REGISTER_FACILITY_APPLICATION_RES = 'REGISTER_FACILITY_APPLICATION_RES';
export const REGISTER_FACILITY_APPLICATION_ERR = 'REGISTER_FACILITY_APPLICATION_ERR';

//Get registered facility list
export const FETCH_FACILITY_APPLICATION_REQ = 'FETCH_FACILITY_APPLICATION_REQ';
export const FETCH_FACILITY_APPLICATION_RES = 'FETCH_FACILITY_APPLICATION_RES';
export const FETCH_FACILITY_APPLICATION_ERR = 'FETCH_FACILITY_APPLICATION_ERR';